import React from 'react';
import styles from './AuditionDetailRoles.module.css';
import AuditionRoleCard from './AuditionRoleCard';

/**
 * @component AuditionDetailRoles
 * @description 모집 역할 탭 — 역할 카드 목록
 *
 * @param {{ id, name, gender, ageRange, payment, description }[]} props.roles
 * @param {Function} props.onRoleApply - 배역 지원 핸들러 (roleId) => void
 */
function AuditionDetailRoles({ roles, onRoleApply, appliedRoleIds, onRoleDetail, isExpired }) {
  if (!roles?.length) {
    return <p className={styles.empty}>등록된 모집 역할이 없습니다.</p>;
  }

  return (
    <div className={styles.list}>
      {roles.map((role) => (
        <AuditionRoleCard key={role.id} role={role} onApply={onRoleApply} appliedRoleIds={appliedRoleIds} onDetail={onRoleDetail} isExpired={isExpired} />
      ))}
    </div>
  );
}

export default AuditionDetailRoles;
